import { RatioTypeEnum, WorkOrderStatusEnum } from 'gql/graphql';
import type { BadgePropStatus } from 'uikit';
import { getTagLabelDefault } from 'uikit/getTagLabelDefault';

export const WorkOrderStatusLabels = {
    [WorkOrderStatusEnum.Completed]: 'Завершен',
    [WorkOrderStatusEnum.Delayed]: 'Отложен',
    [WorkOrderStatusEnum.InProgress]: 'В работе',
    [WorkOrderStatusEnum.OnFormation]: 'На формировании',
};

export const WorkOrderStatusColor = {
    [WorkOrderStatusEnum.Completed]: 'success',
    [WorkOrderStatusEnum.Delayed]: 'system',
    [WorkOrderStatusEnum.InProgress]: 'progress',
    [WorkOrderStatusEnum.OnFormation]: 'normal',
};

export enum ModalWorkOrderEnum {
    WorkOrderUseCoefficient = 'WorkOrderUseCoefficient',
}

export type typeWorkOrderStatusColor = BadgePropStatus | 'progress';

export const getWorkOrderStatusLabel = (code: WorkOrderStatusEnum) => WorkOrderStatusLabels[code];

export const getWorkOrderStatusColor = (code: WorkOrderStatusEnum) =>
    WorkOrderStatusColor[code] as typeWorkOrderStatusColor;

export const getTagLabel = (id: string, name: string, filterValue: any) => {
    if (['code', 'name'].includes(id)) {
        return `${name} содержит '${filterValue || ''}'`;
    }

    return getTagLabelDefault(id, name, filterValue);
};

export type WorkOrderStatuses = {
    followers: WorkOrderStatusEnum[];
    status: WorkOrderStatusEnum;
};

export const coefficientsNames: Record<RatioTypeEnum, string> = {
    [RatioTypeEnum.ConstraintCoef]: 'Коэффициенты стесненности',
    [RatioTypeEnum.TechPartCoef]: 'Коэффициенты технической части',
    [RatioTypeEnum.DismantlingCoef]: 'Коэффициент на демонтаж',
};

export const coefficientsItems = [
    {
        id: RatioTypeEnum.ConstraintCoef,
        label: coefficientsNames[RatioTypeEnum.ConstraintCoef],
    },
    {
        id: RatioTypeEnum.TechPartCoef,
        label: coefficientsNames[RatioTypeEnum.TechPartCoef],
    },
    {
        id: RatioTypeEnum.DismantlingCoef,
        label: coefficientsNames[RatioTypeEnum.DismantlingCoef],
    },
];
